export default __webpack_public_path__ + "static/media/Journal audio bg.6642d087.svg";